function t(i){return/^gid:\/\/shopify\/[^\/]+\/\d+(?:\?.*)?$/.test(i)}export{t as isGid};
//# sourceMappingURL=index.js.map
